import React, { useContext, useEffect, useState } from 'react'
import { DarkModeContext } from '../../global/Theme';
import './index.sass';

export default function SettingThemeChanger() {
    const { isDark, toggleDarkMode } = useContext(DarkModeContext);
    const [active, setActive] = useState(1);

    useEffect(() => {
        if(isDark){
            setActive(0)
            document.getElementById('dark-theme-button').style.background = '#CA3443'
            document.getElementById('dark-theme-button').style.color = 'white'
            document.getElementById('light-theme-button').style.background = 'rgba(202, 52, 67, 0.2)'
            document.getElementById('light-theme-button').style.color = '#CA3443'
        } else {
            setActive(1)
            document.getElementById('light-theme-button').style.background = '#CA3443'
            document.getElementById('light-theme-button').style.color = 'white'
            document.getElementById('dark-theme-button').style.background = 'rgba(202, 52, 67, 0.2)'
            document.getElementById('dark-theme-button').style.color = '#CA3443'
        }
    }, [isDark])

    const setDark = () => {
        setActive(0)
        document.getElementById('dark-theme-button').style.background = '#CA3443'
        document.getElementById('dark-theme-button').style.color = 'white'
        document.getElementById('light-theme-button').style.background = 'rgba(202, 52, 67, 0.2)'
        document.getElementById('light-theme-button').style.color = '#CA3443'
        if(!isDark){
            toggleDarkMode()
        }
    }
    const setlight = () => {
        setActive(1)
        document.getElementById('light-theme-button').style.background = '#CA3443'
        document.getElementById('light-theme-button').style.color = 'white'
        document.getElementById('dark-theme-button').style.background = 'rgba(202, 52, 67, 0.2)'
        document.getElementById('dark-theme-button').style.color = '#CA3443'
        if(isDark){
            toggleDarkMode()
        }
    }
    return (
        <div className='setting-theme-changer'>
            <div id="dark-theme-button" onClick={setDark} >
                <img src={(active == 0) ? require(`../../assets/icons/night_w.svg`) : require(`../../assets/icons/night_a.svg`)} />
                <p>Dark</p>
            </div>
            <div id="light-theme-button" onClick={setlight} >
                <img src={(active == 1) ? require(`../../assets/icons/sun_w.svg`) : require(`../../assets/icons/sun_a.svg`)} />
                <p>Light</p>
            </div>
        </div>
    )
}
